import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { updatePermitApplicationData } from '../../store/slices/apply/applySlice';
import { useAppDispatch } from '../../store/store';
import { selectApplyApplicationData } from '../../store/slices/config/configSelectors';
import { FLOWS_ENUM } from '../../common/enums';
import { ApplicationData } from '../../types/flow';
import { ContactsPage } from '../../components/pages/ContactsPage';

const ApplyContacts = () => {
  const dispatch = useAppDispatch();
  const data = (useSelector(selectApplyApplicationData) ??
    {}) as ApplicationData;

  const updateApplicationData = useCallback(
    (updated: ApplicationData) => {
      dispatch(updatePermitApplicationData(updated));
    },
    [dispatch]
  );

  return (
    <ContactsPage
      data={data}
      flow={FLOWS_ENUM.APPLY_LICENSE}
      updateApplicationData={updateApplicationData}
    />
  );
};

export default ApplyContacts;
